













import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class HelpCircle extends Vue {
  @Prop()
  label: string

  @Prop({
    default: 'is-top'
  })
  position: string

  @Prop({
    default: null
  })
  grayscale: any

  @Prop({
    default: null
  })
  noWrap: any
}
